<!-- MODAL seleccionarFactura -->
<div mdbModal #seleccionarFactura="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg"  role="document">
    <form autocomplete="off" [formGroup]="formData" (ngSubmit)="buscarTodos(true)">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Seleccionar documento
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="seleccionarFactura.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col" style="max-width: 150px;">
              <div class="md-form">
                <input value="" type="text" id="folio" class="form-control" placeholder="Nro. Documento" required #folio
                  formControlName="folio" />
                <label for="folio">Folio</label>
              </div>
            </div>
            <div class="col dato" style="max-width: 150px;">
              <div class="md-form">
                <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha Desde'" required
                  formControlName="fechaDesde">
                </mdb-date-picker>
              </div>
            </div>
            <div class="col dato" style="max-width: 150px;">
              <div class="md-form">
                <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Fecha hasta'" required
                  formControlName="fechaHasta">
                </mdb-date-picker>
              </div>
            </div>
            <div class="col dato" style="max-width: 200px;">
              <div class="md-form">
                <input value="" type="text" id="nombre" class="form-control" placeholder="" required #nombre
                  formatRut formControlName="rut" />
                <label for="nombre">RUT</label>
              </div>
            </div>
            <div class="col dato" style="max-width: 300px;">
              <div class="md-form">
                <input value="" type="text" id="nombre" class="form-control" placeholder="" required #nombre
                  formControlName="nombre" />
                <label for="nombre">Nombre cliente</label>
              </div>
            </div>
          </div>



          <div class="row justify-content-between" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <button mdbBtn type="submit" size="sm" color="info" mdbWavesEffect>
              <mdb-icon fas icon="search"></mdb-icon>
              Buscar
            </button>
          </div>

          <div class="row text-center" *ngIf="loading">
            <div class="col">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </div>
          </div>

          <div class="row" *ngIf="busquedaIniciada && data.length === 0">
            <div class="col">
              <p color="info" class="waves-light" style="text-align-last:center;" mdbWavesEffect>
                No existen registros para el filtro seleccionado</p>
            </div>
          </div>

          <table class="table table-striped table-hover table-sm align-middle mt-1"
            *ngIf="busquedaIniciada && data.length > 0">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Nro. Doc.</th>
                <th scope="col">Fecha</th>
                <th scope="col">Monto Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let documento of data">
                <td>{{ documento.folio }}</td>
                <td>{{ documento.fecha_registro | date }}</td>
                <td>$ {{ documento.monto_total | numerico }}</td>
                <td>
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                    (click)="selectData(documento)">
                    Seleccionar
                  </button>
                </td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"></app-pagination>
          </table>
        </div>
      </div>
    </form>
  </div>
</div>
